import {GamesPageComponent } from "../components/gamesMain"

export const GamesPage = () => {
    return (
       <GamesPageComponent/>
    )
}